<template>
  <i class="mdi mdi-music-accidental-sharp" :style="style"></i>
</template>

<script>
export default {
  props: {
    style: { type: String },
  },
  methods: {},
}
</script>
<style lang="less" scoped>
.mdi {
  color: var(--color-primary);
}

.mdi::before {
  color: inherit;
  font-size: 14px;
  transform: scale(1.7);
  position: relative;
  top: 2px;
  margin-right: 4px;
}
</style>
